/**
 * dayjs 统一入口：集中 locale，避免各处重复引入语言包。
 * 全站业务页可逐步改为从此文件导入；本轮优先供入口与允许改动的页面使用。
 * 体积去重主要依赖 vite manualChunks 的 vendor-dayjs。
 */
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');

export default dayjs;
export { dayjs };
